module.exports = __webpack_public_path__ + "img/icon_plus.1c589c78.svg";